import getApolloClient from '../../app/apollo/getApolloClient';
import { gql } from '../../graphql/generated/gql';

const UPLOAD_POST_ATTACHMENT_MUTATION = gql(`
  mutation uploadPostAttachment($file: Upload!) {
    attachment: uploadPostAttachment(file: $file) {
      url
    }
  }
`);

export default function uploadPostAttachment(file: File) {
  return getApolloClient().then((client) =>
    client
      .mutate({
        mutation: UPLOAD_POST_ATTACHMENT_MUTATION,
        variables: { file },
      })
      .then(({ data }) => data?.attachment.url),
  );
}
